import { useEffect, useRef, useState } from 'react';

export function useInView({ threshold = 0.15, rootMargin = '0px 0px -40px 0px' } = {}) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node || inView) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          obs.disconnect();
        }
      },
      { threshold, rootMargin }
    );
    obs.observe(node);
    return () => obs.disconnect();
  }, [threshold, rootMargin, inView]);

  return [ref, inView];
}

// Convenience: spread on any element to fade-up on scroll.
//   useReveal()              → 'reveal' base (fade + translateY)
//   useReveal({base:'reveal-x'}) → slide in from the left
export function useReveal(opts = {}) {
  const { base = 'reveal', ...obsOpts } = opts;
  const [ref, inView] = useInView(obsOpts);
  return { ref, className: inView ? `${base} in-view` : base };
}
